export const NavbarLinks = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "Catalog",
      // path: '/catalog', // no path bcoz it consist of category
    },
    {
      title: "About",
      path: "/about",
    },
    {
      title: "Contact",
      path: "/contact",
    },
   

  ];